var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content", attrs: { type: "primary" } },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "2400",
                  reset: true,
                  "custom-sim-query-placeholder": _vm.$t(
                    "Message.QuickSearchBusinessNo"
                  )
                },
                on: {
                  "click-more": function(value) {
                    return (_vm.isAdvancedQuery = value)
                  },
                  simSearchItemCallBack: _vm.toSimpleQuery,
                  advSearchItemCallBack: _vm.toAdvancedQuery,
                  advSearchItemResetCallBack: _vm.toAdvancedQuery
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_MblManagement_Register"
                            ]),
                            expression:
                              "$checkPermission(['button_MblManagement_Register'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.registerHandler }
                      },
                      [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_Register")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_MblManagement_Invalid"
                            ]),
                            expression:
                              "$checkPermission(['button_MblManagement_Invalid'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.cancellationHandler }
                      },
                      [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_Invalid")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_MblManagement_OrderDelete"
                            ]),
                            expression:
                              "$checkPermission(['button_MblManagement_OrderDelete'])"
                          }
                        ],
                        attrs: { type: "danger" },
                        on: { click: _vm.deleteHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_OrderDelete")) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_MblManagement_SetAMarginAlert"
                            ]),
                            expression:
                              "$checkPermission(['button_MblManagement_SetAMarginAlert'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.marginReminderHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_SetAMarginAlert")) +
                            " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_MblManagement_Assignment"
                            ]),
                            expression:
                              "$checkPermission(['button_MblManagement_Assignment'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.distributeHandler }
                      },
                      [
                        _vm._v(
                          _vm._s(this.$t("CargoMsg.Cargo_Assignment")) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.importHandler }
                      },
                      [_vm._v(_vm._s(this.$t("CargoMsg.Cargo_Import")) + " ")]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  attrs: {
                    "config-module": "24000522",
                    "grid-params": _vm.gridParams,
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.rowData
                  },
                  on: {
                    "update:gridParams": function($event) {
                      _vm.gridParams = $event
                    },
                    "update:grid-params": function($event) {
                      _vm.gridParams = $event
                    },
                    gridReady: function(params) {
                      return (_vm.gridApi = params.api)
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    "config-module": "24000521",
                    total: _vm.filter.total,
                    "page-count": _vm.pageCount,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.toQuery
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.registerWindow.visible
        ? _c("register-window", {
            attrs: { visible: _vm.registerWindow.visible },
            on: {
              close: function($event) {
                _vm.registerWindow.visible = false
              },
              queryList: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.distributionWindow.visible
        ? _c("distribution-window", {
            attrs: {
              visible: _vm.distributionWindow.visible,
              "mbl-list": _vm.distributionWindow.mblList
            },
            on: {
              close: function($event) {
                _vm.distributionWindow.visible = false
              },
              queryList: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.setReminderWindow.visible
        ? _c("set-reminder-window", {
            attrs: { visible: _vm.setReminderWindow.visible },
            on: {
              close: function($event) {
                _vm.setReminderWindow.visible = false
              },
              queryList: _vm.toQuery
            }
          })
        : _vm._e(),
      _vm.importWindow.visible
        ? _c("import-window", {
            attrs: { visible: _vm.importWindow.visible },
            on: {
              close: function($event) {
                _vm.importWindow.visible = false
              },
              queryList: _vm.toQuery
            }
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("CargoMsg.Cargo_BusinessNoChangeLogRecord"),
            visible: _vm.businessChangeDialog.visible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.businessChangeDialog, "visible", $event)
            },
            close: function($event) {
              _vm.businessChangeDialog.visible = false
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.businessChangeDialog.records } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "businessNo",
                  label: _vm.$t("CargoMsg.Cargo_BusinessNo"),
                  width: "180"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createdBy",
                  label: _vm.$t("CargoMsg.Cargo_OperateBy"),
                  width: "180",
                  formatter: function(row) {
                    return _vm.loadName(row.createdBy)
                  }
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "dateCreated",
                  label: _vm.$t("CargoMsg.Cargo_OperateTime"),
                  formatter: function(row) {
                    return _vm.loadDateTime(row.dateCreated)
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }